import { render, staticRenderFns } from "./IcoSquareDashPlus.vue?vue&type=template&id=2f565a6e"
import script from "./IcoSquareDashPlus.vue?vue&type=script&lang=js"
export * from "./IcoSquareDashPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports